import { z } from 'zod';

/**
 * The dashboard's "Feedback" button: an idea or a comment, a request for help, or a bug. Messages are stored, listed
 * in the admin area and emailed to support (reply-to: the sender).
 */
export const FEEDBACK_KINDS = ['feedback', 'help', 'bug'] as const;
export type FeedbackKind = (typeof FEEDBACK_KINDS)[number];

export const FEEDBACK_KIND_LABEL: Record<FeedbackKind, string> = { feedback: 'Feedback', help: 'Help', bug: 'Bug' };

export const FEEDBACK_STATUSES = ['open', 'done'] as const;
export type FeedbackStatus = (typeof FEEDBACK_STATUSES)[number];

export const createFeedbackSchema = z.object({
  kind: z.enum(FEEDBACK_KINDS),
  message: z.string().trim().min(3, 'Write a few words.').max(5000),
  /** The page it was sent from (path and query). */
  page: z.string().trim().max(500).optional(),
});
export type CreateFeedbackInput = z.infer<typeof createFeedbackSchema>;

export const updateFeedbackSchema = z.object({ status: z.enum(FEEDBACK_STATUSES) });

export interface FeedbackDto {
  id: string;
  kind: FeedbackKind;
  message: string;
  page: string | null;
  email: string | null;
  userId: string | null;
  orgId: string | null;
  orgName: string | null;
  userAgent: string | null;
  status: FeedbackStatus;
  createdAt: string;
}

/** Most messages one user can send in an hour. */
export const FEEDBACK_PER_HOUR = 10;
